import { jsx as _jsx } from "react/jsx-runtime";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useCallback } from "react";
import { ShareButton } from "~/components/AssetModalV2/Header/components/ShareButton";
import { SharePublicClipModal } from "~/components/Modals/SharePublicClipModal";
import { ASSET_SHARE_BUTTON_PUBLIC } from "~/constants/testIDs";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { getPublicClipShareUrl } from "~/swr-hooks/shortUrl/utils";
import { useAirStore } from "~/utils/ReduxUtils";
export const PublicShareButton = /*#__PURE__*/ memo(()=>{
    const store = useAirStore();
    const [sharePublicClip] = useAirModal(SharePublicClipModal);
    const { shortId } = useShortIdContext();
    const onClick = useCallback(()=>{
        const clipId = centralizedClipIdSelector(store.getState());
        sharePublicClip({
            id: clipId,
            url: getPublicClipShareUrl(shortId),
            trackLocation: "public-asset-page"
        });
    }, [
        sharePublicClip,
        shortId,
        store
    ]);
    return /*#__PURE__*/ _jsx(ShareButton, {
        onClick: onClick,
        dataTestId: ASSET_SHARE_BUTTON_PUBLIC
    });
});
PublicShareButton.displayName = "PublicShareButton ";
